// QA ILT-01 / ILT-02: mesaj türü → o türe ait konular. Liste varsayılandır; markanın müşteri hizmetleri
// sınıflandırmasıyla teyit edilip buradan güncellenmelidir (tek kaynak).
const HP_CONTACT_MESSAGE_TOPICS = {
  "Bilgi Talebi": ["Sipariş Durumu", "Ürün Bilgisi", "Teslimat / Kargo", "İade / Değişim", "Ödeme", "Üyelik", "Mağazalar", "Diğer"],
  Şikayet: ["Sipariş / Teslimat", "Ürün Kalitesi", "İade / Değişim Süreci", "Ödeme / Fatura", "Mağaza Deneyimi", "Web Sitesi / Uygulama", "Diğer"],
  Öneri: ["Ürün / Koleksiyon", "Web Sitesi / Uygulama", "Mağazalar", "Kampanyalar", "Diğer"],
  Teşekkür: ["Ürün", "Müşteri Hizmetleri", "Mağaza", "Diğer"],
};

// QA ILT-07: kontrol kodu — karıştırılabilecek karakterler (0/O, 1/I/L) yok.
const HP_CONTACT_CAPTCHA_CHARSET = "ABCDEFGHJKMNPQRSTUVWXYZ23456789";
const HP_CONTACT_CAPTCHA_LENGTH = 5;

// Yalnızca genişletilmiş (müşteri ilişkileri) formda doğrulanan alanlar.
const HP_CONTACT_EXTENDED_FIELDS = ["messageType", "messageSubject", "messageTitle", "captcha"];

function hpContactEmptyFieldState() {
  return {
    messageType: false,
    messageSubject: false,
    messageTitle: false,
    name: false,
    surname: false,
    email: false,
    phone: false,
    message: false,
    captcha: false,
  };
}

document.addEventListener("alpine:init", () => {
  Alpine.data("hpLegalContactForm", () => ({
    name: "",
    surname: "",
    email: "",
    phone: "",
    message: "",
    honeypot: "",
    privacyAccepted: false,
    isSubmitting: false,
    errorMessage: "",
    successMessage: "",
    touched: hpContactEmptyFieldState(),
    fieldInvalid: hpContactEmptyFieldState(),
    strings: {},

    // QA ILT-01/02/03/06/07/08 — genişletilmiş alanlar (kurumsal satış / franchise formlarında kapalı).
    extended: false,
    messageTypes: Object.keys(HP_CONTACT_MESSAGE_TOPICS),
    messageType: "",
    messageSubject: "",
    messageTitle: "",
    contactPreference: "E-posta",
    orders: [],
    selectedOrder: "",
    selectedProduct: "",
    captchaCode: "",
    captchaInput: "",

    init() {
      const fields = ["name", "surname", "email", "phone", "message", "messageTitle", "captchaInput"];

      fields.forEach((field) => {
        this.$watch(field, () => {
          const key = field === "captchaInput" ? "captcha" : field;
          if (this.touched[key]) {
            this.validateField(key);
          }
        });
      });

      const stringsNode = this.$root.querySelector("[data-hp-contact-strings]");
      if (stringsNode) {
        try {
          this.strings = JSON.parse(stringsNode.textContent || "{}");
        } catch (error) {
          this.strings = {};
        }
      }

      this.extended = this.$root.dataset.extended === "true";
      if (!this.extended) return;

      const ordersNode = this.$root.querySelector("[data-hp-contact-orders]");
      if (ordersNode) {
        try {
          const parsed = JSON.parse(ordersNode.textContent || "[]");
          this.orders = Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          this.orders = [];
        }
      }

      this.$nextTick(() => this.refreshCaptcha());
    },

    get messageSubjects() {
      return HP_CONTACT_MESSAGE_TOPICS[this.messageType] || [];
    },

    get orderProducts() {
      const order = this.orders.find((item) => item.name === this.selectedOrder);
      return order && Array.isArray(order.items) ? order.items : [];
    },

    onMessageTypeChange() {
      this.messageSubject = "";
      this.touchField("messageType");
      if (this.touched.messageSubject) this.validateField("messageSubject");
    },

    refreshCaptcha() {
      let code = "";
      for (let index = 0; index < HP_CONTACT_CAPTCHA_LENGTH; index += 1) {
        code += HP_CONTACT_CAPTCHA_CHARSET[Math.floor(Math.random() * HP_CONTACT_CAPTCHA_CHARSET.length)];
      }

      this.captchaCode = code;
      this.captchaInput = "";
      this.touched.captcha = false;
      this.fieldInvalid.captcha = false;
      this.$nextTick(() => this.drawCaptcha());
    },

    drawCaptcha() {
      const canvas = this.$refs.captchaCanvas;
      const context = canvas?.getContext?.("2d");
      if (!context) return;

      const { width, height } = canvas;
      context.clearRect(0, 0, width, height);
      context.fillStyle = "#f4f4f4";
      context.fillRect(0, 0, width, height);

      for (let index = 0; index < 6; index += 1) {
        context.strokeStyle = `rgba(0, 0, 0, ${0.12 + Math.random() * 0.18})`;
        context.beginPath();
        context.moveTo(Math.random() * width, Math.random() * height);
        context.lineTo(Math.random() * width, Math.random() * height);
        context.stroke();
      }

      context.font = "600 26px monospace";
      context.textBaseline = "middle";
      context.fillStyle = "#111";

      Array.from(this.captchaCode).forEach((character, index) => {
        context.save();
        context.translate(18 + index * 29, height / 2 + (Math.random() * 8 - 4));
        context.rotate(Math.random() * 0.5 - 0.25);
        context.fillText(character, 0, 0);
        context.restore();
      });
    },

    validateCaptcha() {
      return this.captchaInput.trim().toUpperCase() === this.captchaCode;
    },

    validateName(value) {
      const trimmed = (value || "").trim();
      return trimmed.length >= 2;
    },

    validateSurname(value) {
      const trimmed = (value || "").trim();
      return trimmed.length >= 2;
    },

    validateEmail(value) {
      return typeof EMAIL_REGEX !== "undefined" && EMAIL_REGEX.test((value || "").trim());
    },

    // QA ILT-05: Maske `0(5xx) xxx xx xx` = baştaki 0 + 10 hane. Eski kontrol (`digits.length >= 10`)
    // baştaki 0'ı da saydığı için bir hanesi eksik numarayı geçerli kabul ediyordu ("EKSİK RAKAM KABUL ETTİ").
    // QA R71 / R86 (3. tur): müşteri ilişkileri (extended) formunda cep telefonu zorunlu → ulusal numara 5 ile
    // başlamalı (5XX XXX XX XX). Kurumsal satış / franchise formları sabit hat kabul etmeye devam eder.
    // Ulusal numara hiçbir formda 0 ile başlayamaz (maskeye iki kez 0 yazılınca oluşan "0(053) …" gibi girişler).
    validatePhone(value) {
      const national = (value || "").replace(/\D/g, "").replace(/^0/, "");
      if (national.length !== 10 || national.charAt(0) === "0") return false;
      return !this.extended || national.charAt(0) === "5";
    },

    text(key) {
      return this.strings.errors?.[key] || "";
    },

    topicLabel(value) {
      return this.strings.topics?.[value] || value;
    },

    getPhoneErrorMessage() {
      return this.text(this.extended ? "mobile" : "phone");
    },

    validateMessage(value) {
      return (value || "").trim().length > 0;
    },

    touchField(field) {
      this.touched[field] = true;
      this.validateField(field);
    },

    validateField(field) {
      if (HP_CONTACT_EXTENDED_FIELDS.includes(field)) {
        if (!this.extended) {
          this.fieldInvalid[field] = false;
        } else if (field === "captcha") {
          this.fieldInvalid.captcha = !this.validateCaptcha();
        } else {
          this.fieldInvalid[field] = String(this[field] || "").trim() === "";
        }
        return;
      }

      if (field === "name") {
        this.fieldInvalid.name = !this.validateName(this.name);
      } else if (field === "surname") {
        this.fieldInvalid.surname = !this.validateSurname(this.surname);
      } else if (field === "email") {
        this.fieldInvalid.email = !this.validateEmail(this.email);
      } else if (field === "phone") {
        this.fieldInvalid.phone = !this.validatePhone(this.phone);
      } else if (field === "message") {
        this.fieldInvalid.message = !this.validateMessage(this.message);
      }
    },

    getFieldErrorMessage(field) {
      if (!this.touched[field] || !this.fieldInvalid[field]) {
        return "";
      }

      const messages = {
        name: this.text("nameLength"),
        surname: this.text("surnameLength"),
        email: this.text("email"),
        phone: this.getPhoneErrorMessage(),
        message: this.text("message"),
        messageType: this.text("messageType"),
        messageSubject: this.text("messageSubject"),
        messageTitle: this.text("messageTitle"),
        captcha: this.text("captcha"),
      };

      return messages[field] || "";
    },

    get isFormValid() {
      const extendedValid =
        !this.extended ||
        (this.messageType !== "" &&
          this.messageSubject !== "" &&
          this.messageTitle.trim() !== "" &&
          this.captchaInput.trim().length === HP_CONTACT_CAPTCHA_LENGTH);

      return (
        extendedValid &&
        this.validateName(this.name) &&
        this.validateSurname(this.surname) &&
        this.validateEmail(this.email) &&
        this.validatePhone(this.phone) &&
        this.validateMessage(this.message) &&
        this.privacyAccepted
      );
    },

    markAllTouched() {
      const touched = hpContactEmptyFieldState();
      Object.keys(touched).forEach((field) => {
        touched[field] = true;
      });
      this.touched = touched;
    },

    // Genişletilmiş alanlar backend sözleşmesini bozmamak için ayrı `TextValues[...]` anahtarı olarak
    // değil, mevcut "Mesaj" alanının başına okunur satırlar olarak eklenir.
    buildMessageBody() {
      const message = this.message.trim();
      if (!this.extended) return message;

      const lines = [
        `Mesaj Türü: ${this.messageType}`,
        `Mesaj Konusu: ${this.messageSubject}`,
        `Mesaj Başlığı: ${this.messageTitle.trim()}`,
        `İletişim Tercihi: ${this.contactPreference}`,
      ];

      if (this.selectedOrder) lines.push(`Sipariş: ${this.selectedOrder}`);
      if (this.selectedProduct) lines.push(`Ürün: ${this.selectedProduct}`);

      return `${lines.join("\n")}\n\n${message}`;
    },

    async handleSubmit() {
      this.errorMessage = "";
      this.successMessage = "";
      this.markAllTouched();

      Object.keys(this.touched).forEach((field) => {
        this.validateField(field);
      });

      if (this.extended) {
        if (!this.messageType) {
          this.errorMessage = this.text("messageType");
          return;
        }

        if (!this.messageSubject) {
          this.errorMessage = this.text("messageSubject");
          return;
        }

        if (!this.messageTitle.trim()) {
          this.errorMessage = this.text("messageTitle");
          return;
        }
      }

      if (!this.validateName(this.name)) {
        this.errorMessage = this.text("name");
        return;
      }

      if (!this.validateSurname(this.surname)) {
        this.errorMessage = this.text("surname");
        return;
      }

      if (!this.validateEmail(this.email)) {
        this.errorMessage = this.text("email");
        return;
      }

      if (!this.validatePhone(this.phone)) {
        this.errorMessage = this.getPhoneErrorMessage();
        return;
      }

      if (!this.validateMessage(this.message)) {
        this.errorMessage = this.text("message");
        return;
      }

      if (!this.privacyAccepted) {
        this.errorMessage = this.text("privacy");
        return;
      }

      if (this.extended && !this.validateCaptcha()) {
        this.refreshCaptcha();
        this.touched.captcha = true;
        this.fieldInvalid.captcha = true;
        this.errorMessage = this.text("captcha");
        return;
      }

      this.isSubmitting = true;

      try {
        const formData = new FormData();
        const formTitle = this.$root.dataset.formTitle || "Müşteri İlişkileri İletişim Formu";

        formData.append("Email", this.email.trim());
        formData.append("FormTitle", formTitle);
        formData.append("TextValues[Ad]", this.name.trim());
        formData.append("TextValues[Soyad]", this.surname.trim());
        formData.append("TextValues[Telefon]", this.phone.trim());
        formData.append("TextValues[Mesaj]", this.buildMessageBody());

        if (this.honeypot && this.honeypot.trim() !== "") {
          formData.append("MiddleName", this.honeypot.trim());
        }

        const response = await fetch(HC_API.SEND_CONTACT_FORM, {
          method: "POST",
          body: formData,
        });
        const result = await response.json();

        if (response.ok && result.isSuccess === true && result.statusCode === 200) {
          this.successMessage = this.$root.dataset.successMessage;

          this.name = "";
          this.surname = "";
          this.email = "";
          this.phone = "";
          this.message = "";
          this.privacyAccepted = false;
          this.messageType = "";
          this.messageSubject = "";
          this.messageTitle = "";
          this.contactPreference = "E-posta";
          this.selectedOrder = "";
          this.selectedProduct = "";
          this.touched = hpContactEmptyFieldState();
          this.fieldInvalid = hpContactEmptyFieldState();
          if (this.extended) this.refreshCaptcha();

          setTimeout(() => {
            this.successMessage = "";
          }, 15000);
        } else {
          this.errorMessage =
            result.message || this.text("submit");
        }
      } catch (error) {
        console.error("Contact form submission error:", error);
        this.errorMessage = this.text("submit");
      } finally {
        this.isSubmitting = false;
      }
    },
  }));
});
